export const packItem = {
    "go-to-title": "acquérir ce pack",
    "as-of": "à partir de",
    "month": "mois",
    "ht": "HT",
    'already-use': "Vous possédez déjà ce pack ! Inutile donc de l'acheter à nouveau.",
    'choice-offers': "3 offres au choix"
}
